import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { TextAreaField } from '../../../../TextAreaField';
import { CloseWrapper, useBlockToolInputFocus } from '../../helpers';

import classNames from 'classnames';
import classes from './CodeNodeView.module.scss';

export const CodeNodeView: FunctionComponent<NodeViewProps> = ({
  editor,
  node,
  getPos,
  updateAttributes,
}) => {
  const { t } = useTranslation();

  const { onBlockInputFocus } = useBlockToolInputFocus({ editor, getPos });

  const { code } = node.attrs;

  return (
    <NodeViewWrapper as={'div'} className={classNames(classes['code'])}>
      <CloseWrapper editor={editor} node={node} getPos={getPos}>
        <TextAreaField
          placeholder={t('richTextEditor.code-config-placeholder')}
          value={code}
          onChange={({ target }) => updateAttributes({ code: target.value })}
          onFocus={onBlockInputFocus}
          minRows={2}
        />
      </CloseWrapper>
    </NodeViewWrapper>
  );
};
